import { useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { GetPostPagination } from '../../usecases/get-post-pagination.js';
import { PaginationHelper } from '../../usecases/pagination-helper.js';
import { useGetSections } from './use-get-sections.js';

const useGetPagination = ({
  productId
}, isBeta = false) => {
  const {
    data
  } = useGetSections({
    productId
  }, isBeta);
  const {
    postId
  } = useParams();
  const pagination = new GetPostPagination().execute({
    postId,
    sections: data
  });
  const getPagination = useCallback(() => PaginationHelper.getPaginationData(data !== null && data !== void 0 ? data : [], postId, pagination), [data, postId, pagination]);
  return {
    getPagination
  };
};

export { useGetPagination };
